import Image from 'next/image';
import { FC } from 'react';

export interface ImageRowProps {
  blok: any;
}

const ImageRow: FC<ImageRowProps> = ({ blok }) => {
  return (
    <div key={blok.blokuid} className="not-prose flex flex-nowrap gap-2">
      {blok.images.map((image) => (
        <div
          key={image?.id}
          className="group relative my-1 inline-flex min-w-0 shrink grow-0"
        >
          <Image
            alt={image?.alt}
            src={`${image?.filename}/m/0x800`}
            className="!my-0"
            fill
            sizes="100vw"
          />
          <p className="bg-gradient-radial-to-tl text-2xs absolute bottom-0 right-0 z-10 !m-0 w-full from-black/50 to-transparent p-2 pt-6 font-mono text-white duration-300 empty:hidden group-hover:opacity-100 md:text-xs md:opacity-0 lg:text-right">
            {image?.title && `${image?.title}`}
            {image?.copyright && ` © ${image?.copyright}`}
            {image?.source && ` / ${image?.source}`}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ImageRow;
